import { Box, Checkbox, Typography, TableRow, TableCell } from '@mui/material';
import { StoreTargetMapping } from 'src/models/storetarget';

interface Props {
  filteredTargets: StoreTargetMapping[];
  columns: string[];
  isAllTargetsSelected: boolean;
  onSelectAllTargets: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean,
  ) => void;
}

export default function StoreMappingHeaderRow({
  columns,
  isAllTargetsSelected,
  onSelectAllTargets,
  filteredTargets,
}: Props) {
  return (
    <TableRow>
      {columns.map((column) => (
        <TableCell key={column}>
          <Box sx={{ display: column === 'Store' ? 'flex' : 'table-cell' }}>
            {column === 'Store' && (
              <Checkbox
                checked={isAllTargetsSelected}
                onChange={onSelectAllTargets}
                disabled={filteredTargets.length === 0}
                size="small"
                sx={{
                  color: 'secondary.dark',
                  padding: 0,
                  '&.Mui-checked': {
                    color: 'primary.light',
                  },
                }}
              />
            )}
            <Typography
              variant="body2"
              sx={{ paddingLeft: '8px', color: 'fileInput.dark' }}
            >
              {column}
            </Typography>
          </Box>
        </TableCell>
      ))}
    </TableRow>
  );
}
